module.exports = __webpack_public_path__ + "img/hearts.b56c66.svg";